import { useState, useEffect } from 'react';
import { getPublicBasePathFromHostname } from '../utils/getPublicBasePathFromHostname';
import { StaticDomainConfiguration } from '../../../../../../../../page-frame-types/StaticDomainConfiguration';
import { BASE_PATHS } from '../constants';

export const useSVGImageState = (staticDomain: StaticDomainConfiguration | undefined) => {
    const { host, protocol } = staticDomain ?? {};
    const staticPath = host && protocol ? `${protocol}://${host}` : BASE_PATHS.TEST;
    const [basePath, setBasePath] = useState(staticPath);

    useEffect(() => {
        if (host && protocol) {
            setBasePath(`${protocol}://${host}`);
        } else {
            setBasePath(getPublicBasePathFromHostname());
        }
    }, [host, protocol]);
    return {
        basePath,
    };
};
